
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/neurosurgery",
      function () {
        return require("private-next-pages/neurosurgery.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/neurosurgery"])
      });
    }
  